declare namespace $ {

	type $mol_view__sub_shm_projects_page_1 = $mol_type_enforce<
		ReturnType< $shm_projects_page['menu_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_projects_page_2 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_4 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_description'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_5 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_problem'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_7 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_problem'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_8 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_audience'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_10 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_audience'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_11 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_13 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_value'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_14 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_scenarios'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_16 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_scenarios'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_17 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_success'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_19 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_success'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__value_shm_projects_page_20 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_stage'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_projects_page_21 = $mol_type_enforce<
		({ 
			'idea': string,
			'prototype': string,
			'mvp': string,
			'growing': string,
			'support': string,
			'archived': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_form_field__name_shm_projects_page_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_23 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_stage'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form__form_fields_shm_projects_page_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__submit_title_shm_projects_page_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['submit_title'] >
	>
	type $mol_form__message_done_shm_projects_page_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['message_done'] >
	>
	type $mol_form__save_shm_projects_page_27 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_save'] >
		,
		ReturnType< $mol_form['save'] >
	>
	type $mol_textarea__hint_shm_projects_page_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_projects_page_29 = $mol_type_enforce<
		ReturnType< $shm_projects_page['draft_note'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_shm_projects_page_30 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_mode_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_31 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_stage_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_goal__project_id_shm_projects_page_32 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_goal['project_id'] >
	>
	type $shm_projects_goal__version_shm_projects_page_33 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_next'] >
		,
		ReturnType< $shm_projects_goal['version'] >
	>
	type $shm_projects_goal__output_mode_shm_projects_page_34 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_output_mode'] >
		,
		ReturnType< $shm_projects_goal['output_mode'] >
	>
	type $shm_projects_goal__after_shm_projects_page_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_projects_goal['after'] >
	>
	type $shm_projects_tests__project_id_shm_projects_page_36 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_tests['project_id'] >
	>
	type $mol_view__sub_shm_projects_page_37 = $mol_type_enforce<
		ReturnType< $shm_projects_page['preview_mode_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__hint_shm_projects_page_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__uri_shm_projects_page_39 = $mol_type_enforce<
		ReturnType< $shm_projects_page['preview_open_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_40 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_projects_page_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_frame__uri_shm_projects_page_42 = $mol_type_enforce<
		ReturnType< $shm_projects_page['preview_url'] >
		,
		ReturnType< $mol_frame['uri'] >
	>
	type $mol_frame__style_shm_projects_page_43 = $mol_type_enforce<
		({ 
			'pointerEvents': ReturnType< $shm_projects_page['preview_pointer_events'] >,
		})  & ReturnType< $mol_frame['style'] >
		,
		ReturnType< $mol_frame['style'] >
	>
	type $mol_list__rows_shm_projects_page_44 = $mol_type_enforce<
		ReturnType< $shm_projects_page['rollback_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_shm_projects_page_45 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_transition'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_projects_page_46 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__value_shm_projects_page_47 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_changes'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_49 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Prerelease_changes'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_button_major__title_shm_projects_page_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_page_51 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_make'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_projects_page_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_projects_page_53 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_54 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_shm_projects_page_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_57 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_58 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_mode_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_59 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_selected_date'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_60 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_action_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_62 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_selected_requirements'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_65 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_67 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_68 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_test_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_71 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_projects_page_73 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_screenshot_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_shm_projects_page_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_image__decoding_shm_projects_page_75 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['decoding'] >
	>
	type $mol_view__sub_shm_projects_page_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_content_shm_projects_page_78 = $mol_type_enforce<
		ReturnType< $shm_projects_page['menu_title_rows'] >
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_page_79 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_string_button__value_shm_projects_page_80 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_projects_page_81 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_projects_page_82 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_projects_page['project_title_commit'] > ): ReturnType< $shm_projects_page['project_title_commit'] >,
			keydown( next?: ReturnType< $shm_projects_page['project_title_keydown'] > ): ReturnType< $shm_projects_page['project_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $shm_service_task_menu__remove_title_shm_projects_page_83 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_menu['remove_title'] >
	>
	type $shm_service_task_menu__remove_confirm_title_shm_projects_page_84 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_menu['remove_confirm_title'] >
	>
	type $shm_service_task_menu__remove_shm_projects_page_85 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_delete'] >
		,
		ReturnType< $shm_service_task_menu['remove'] >
	>
	type $mol_text__text_shm_projects_page_86 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link__arg_shm_projects_page_87 = $mol_type_enforce<
		ReturnType< $shm_projects_page['section_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_88 = $mol_type_enforce<
		ReturnType< $shm_projects_page['section_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_page__title_shm_projects_page_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_projects_page_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_projects_tasks__project_id_shm_projects_page_94 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_tasks['project_id'] >
	>
	type $mol_page__title_content_shm_projects_page_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_page_96 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_projects_goal_output__mode_shm_projects_page_97 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_output_mode'] >
		,
		ReturnType< $shm_projects_goal_output['mode'] >
	>
	type $shm_projects_goal_output__process_shm_projects_page_98 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Development_process'] >
		,
		ReturnType< $shm_projects_goal_output['process'] >
	>
	type $shm_projects_goal_output__result_shm_projects_page_99 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Development_result'] >
		,
		ReturnType< $shm_projects_goal_output['result'] >
	>
	type $shm_projects_docs__menu_title_shm_projects_page_100 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_docs['menu_title'] >
	>
	type $shm_projects_docs__readme_text_shm_projects_page_101 = $mol_type_enforce<
		ReturnType< $shm_projects_page['docs_readme_text'] >
		,
		ReturnType< $shm_projects_docs['readme_text'] >
	>
	type $shm_projects_docs__agents_text_shm_projects_page_102 = $mol_type_enforce<
		ReturnType< $shm_projects_page['docs_agents_text'] >
		,
		ReturnType< $shm_projects_docs['agents_text'] >
	>
	type $shm_projects_docs__config_text_shm_projects_page_103 = $mol_type_enforce<
		ReturnType< $shm_projects_page['docs_config_text'] >
		,
		ReturnType< $shm_projects_docs['config_text'] >
	>
	type $mol_page__title_shm_projects_page_104 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_content_shm_projects_page_106 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_projects_page_107 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_projects_page_108 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__current_shm_projects_page_109 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_mode_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_page_110 = $mol_type_enforce<
		({ 
			'project_tab': string,
			'project_preview': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_111 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_112 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__current_shm_projects_page_113 = $mol_type_enforce<
		ReturnType< $shm_projects_page['preview_mode'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_page_114 = $mol_type_enforce<
		({ 
			'project_tab': string,
			'project_preview': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_115 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_116 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__current_shm_projects_page_117 = $mol_type_enforce<
		ReturnType< $shm_projects_page['development_mode_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_page_118 = $mol_type_enforce<
		({ 
			'project_tab': string,
			'project_preview': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_119 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_120 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__current_shm_projects_page_121 = $mol_type_enforce<
		ReturnType< $shm_projects_page['preview_mode'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_page_122 = $mol_type_enforce<
		({ 
			'project_tab': string,
			'project_preview': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_123 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_pick__hint_shm_projects_page_125 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_projects_page_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_projects_page_127 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_projects_page_128 = $mol_type_enforce<
		ReturnType< $shm_projects_page['rollback_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_page_129 = $mol_type_enforce<
		ReturnType< $shm_projects_page['rollback'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_page__title_shm_projects_page_130 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_131 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_projects_page_132 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_projects_page_133 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_134 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_135 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_136 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_page__title_content_shm_projects_page_138 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_page_139 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_content'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_140 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_result_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_141 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_result_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_142 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_143 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_projects_page_144 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_145 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_146 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_147 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_148 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_149 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_goal_chat__run_shm_projects_page_150 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_run'] >
		,
		ReturnType< $shm_projects_goal_chat['run'] >
	>
	type $shm_projects_goal_chat__iteration_shm_projects_page_151 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_iteration'] >
		,
		ReturnType< $shm_projects_goal_chat['iteration'] >
	>
	type $shm_projects_goal_chat__prerelease_shm_projects_page_152 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_prerelease'] >
		,
		ReturnType< $shm_projects_goal_chat['prerelease'] >
	>
	type $shm_projects_goal_chat__version_shm_projects_page_153 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_version'] >
		,
		ReturnType< $shm_projects_goal_chat['version'] >
	>
	type $mol_button_major__title_shm_projects_page_154 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_page_155 = $mol_type_enforce<
		ReturnType< $shm_projects_page['release_make'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_shm_projects_page_156 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_page_157 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_activate'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_projects_page_158 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_release_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_159 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_160 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_161 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_162 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_screenshot_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_projects_page_163 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_screenshot_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_164 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_projects_page_165 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__uri_shm_projects_page_166 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_test_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_167 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_projects_page_168 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__uri_shm_projects_page_169 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_170 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_shm_projects_page_171 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_projects_page_172 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_page extends $mol_book2 {
		project_pages( ): readonly(any)[]
		menu_title_rows( ): readonly(any)[]
		menu_rows( ): readonly(any)[]
		Menu( ): $mol_view
		project_title_draft( next?: string ): string
		project_title_commit( next?: any ): any
		project_title_keydown( next?: any ): any
		project_delete( next?: any ): any
		version_label( ): string
		section_arg( id: any): Record<string, any>
		section_title( id: any): string
		product_description( next?: string ): string
		Product_description( ): $mol_textarea
		Product_description_field( ): $mol_form_field
		product_problem( next?: string ): string
		Product_problem( ): $mol_textarea
		Product_problem_field( ): $mol_form_field
		product_audience( next?: string ): string
		Product_audience( ): $mol_textarea
		Product_audience_field( ): $mol_form_field
		product_value( next?: string ): string
		Product_value( ): $mol_textarea
		Product_value_field( ): $mol_form_field
		product_scenarios( next?: string ): string
		Product_scenarios( ): $mol_textarea
		Product_scenarios_field( ): $mol_form_field
		product_success( next?: string ): string
		Product_success( ): $mol_textarea
		Product_success_field( ): $mol_form_field
		product_stage( next?: string ): string
		Product_stage( ): $mol_select
		Product_stage_field( ): $mol_form_field
		product_save( next?: any ): any
		Product_form( ): $mol_form
		draft_note( next?: string ): string
		Draft( ): $mol_textarea
		development_mode_rows( ): readonly(any)[]
		Development_modes( ): $mol_view
		version_next( ): string
		development_output_mode( next?: string ): string
		development_result_visible( ): ReturnType< ReturnType< $shm_projects_page['Development'] >['result_visible'] >
		Development_process( ): ReturnType< ReturnType< $shm_projects_page['Development'] >['Process'] >
		Development_result( ): ReturnType< ReturnType< $shm_projects_page['Development'] >['Result'] >
		Development_thinking( ): ReturnType< ReturnType< $shm_projects_page['Development'] >['Thinking'] >
		development_stage_rows( ): readonly(any)[]
		Development_stage( ): $mol_view
		Development( ): $shm_projects_goal
		docs_readme_text( ): string
		docs_agents_text( ): string
		docs_config_text( ): string
		Project_tests( ): $shm_projects_tests
		preview_mode_rows( ): readonly(any)[]
		Preview_modes( ): $mol_view
		preview_open_uri( ): string
		Preview_open_icon( ): $mol_icon_open_in_new
		Preview_open( ): $mol_link
		preview_url( ): string
		preview_pointer_events( ): string
		Preview( ): $mol_frame
		development_mode_current( ): boolean
		preview_mode( ): boolean
		Development_actions_icon( ): $mol_icon_dots_vertical
		rollback_rows( ): readonly(any)[]
		Development_actions_list( ): $mol_list
		rollback_title( id: any): string
		rollback( id: any, next?: any ): any
		prerelease_transition( ): string
		Prerelease_transition( ): $mol_text
		prerelease_status( ): string
		Prerelease_deployment( ): $mol_text
		version_changes( next?: string ): string
		Prerelease_changes( ): $mol_textarea
		Prerelease_changes_field( ): $mol_form_field
		prerelease_make( next?: any ): any
		Prerelease_make( ): $mol_button_major
		Prerelease_form( ): $mol_view
		prerelease_uri( ): string
		Prerelease_open( ): $mol_link
		version_rows( ): readonly(any)[]
		Versions( ): $mol_view
		version_arg( id: any): Record<string, any>
		version_title( id: any): string
		version_mode_rows( ): readonly(any)[]
		Version_modes( ): $mol_view
		version_content( ): readonly(any)[]
		version_result_arg( ): Record<string, any>
		version_result_current( ): boolean
		version_session_arg( ): Record<string, any>
		version_session_current( ): boolean
		version_selected_date( ): string
		Version_date( ): $mol_text
		version_action_rows( ): readonly(any)[]
		Version_actions( ): $mol_view
		Requirements_title( ): $mol_view
		version_selected_requirements( ): string
		Version_requirements( ): $mol_text
		Requirements_section( ): $mol_view
		Changes_title( ): $mol_view
		change_rows( ): readonly(any)[]
		Changes( ): $mol_list
		Changes_section( ): $mol_view
		version_tests_title( ): string
		Tests_title( ): $mol_view
		version_test_rows( ): readonly(any)[]
		Version_tests( ): $mol_list
		Tests_section( ): $mol_view
		Other_artifacts_title( ): $mol_view
		other_artifact_rows( ): readonly(any)[]
		Other_artifacts( ): $mol_list
		Other_artifacts_section( ): $mol_view
		version_session_rows( ): readonly(any)[]
		version_session_prerelease( id: any): boolean
		version_session_version( ): string
		release_make( next?: any ): any
		prerelease_activate( next?: any ): any
		version_release_status( ): string
		change_content( id: any): readonly(any)[]
		change_title( id: any): string
		change_description( id: any): string
		change_screenshot_rows( id: any): readonly(any)[]
		change_screenshot_uri( id: any): string
		Change_screenshot_image( id: any): $mol_image
		version_test_uri( id: any): string
		version_test_status( id: any): string
		Version_test_status( id: any): $mol_view
		version_test_title( id: any): string
		Version_test_title( id: any): $mol_view
		other_artifact_uri( id: any): string
		other_artifact_title( id: any): string
		project_id( ): string
		pages( ): ReturnType< $shm_projects_page['project_pages'] >
		Menu_page( ): $mol_page
		Menu_title( ): $mol_string_button
		Project_actions( ): $shm_service_task_menu
		Version_label( ): $mol_text
		Section_link( id: any): $mol_link
		Product_page( ): $mol_page
		Draft_page( ): $mol_page
		Tasks( ): $shm_projects_tasks
		Development_page( ): $mol_page
		Development_output( ): $shm_projects_goal_output
		Docs( ): $shm_projects_docs
		Tests_page( ): $mol_page
		Preview_page( ): $mol_page
		Development_development( ): $mol_link
		Development_preview( ): $mol_link
		Preview_development( ): $mol_link
		Preview_preview( ): $mol_link
		Development_actions( ): $mol_pick
		Rollback( id: any): $mol_button_minor
		Prerelease_page( ): $mol_page
		Prerelease_summary( ): $mol_view
		History_page( ): $mol_page
		Version_link( id: any): $mol_link
		Version_page( ): $mol_page
		Version_result_mode( ): $mol_link
		Version_session_mode( ): $mol_link
		Version_details( ): $mol_view
		Version_session( ): $mol_view
		version_session_run( ): any
		version_session_iteration( id: any): number
		Version_session_chat( id: any): $shm_projects_goal_chat
		Version_release( ): $mol_button_major
		Version_prerelease( ): $mol_button_major
		Version_release_state( ): $mol_text
		Change( id: any): $mol_view
		Change_title( id: any): $mol_view
		Change_description( id: any): $mol_text
		Change_screenshots( id: any): $mol_view
		Change_screenshot( id: any): $mol_link
		Version_test( id: any): $mol_link
		Other_artifact( id: any): $mol_link
		No_other_artifacts( ): $mol_view
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map